import React from 'react'

import { OverlayProvider } from './src/components/OverlayContext'

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = ({ element }) => (
  <OverlayProvider>{element}</OverlayProvider>
)
